import { useTranslation } from "react-i18next";

import useImportStatuses from "./useImportStatuses";

export default function useImportsRefinements() {
	const { t } = useTranslation();

	const importStatuses = useImportStatuses();

	return [
		{
			header: t("source", "Source"),
			attribute: "source",
		},
		{
			header: t("status", "Status"),
			attribute: "status",
			renderItem: ({ label }) => importStatuses[label].text,
		},
	];
}
